import React from "react";
import {IconApple, IconCreditCardDefault, IconLitigation} from "@bounce/shared/ui";
import {PaymentMethod, PaymentMethodDisplayPolicy} from "../../../apis/requests/payment-flows/types";

export const PAYMENT_METHODS = ["ach", "card", "apple_pay"] as const satisfies readonly PaymentMethod[];

export const PAYMENT_METHOD_OPTIONS: Record<
  PaymentMethod,
  {label: string; Icon: React.FC<React.SVGProps<SVGSVGElement>>}
> = {
  card: {label: "Card", Icon: IconCreditCardDefault},
  ach: {label: "ACH", Icon: IconLitigation},
  apple_pay: {label: "Apple Pay", Icon: IconApple},
};

export const CURRENT_CHECKOUT_POLICY: PaymentMethodDisplayPolicy = {methods: [...PAYMENT_METHODS], default: "ach"};

export const DISPLAY_CONDITION_PARAMETERS = new Set(["partner_code"]);
